<template>
        <!-- Navigation Start -->
        <nav class="navbar navbar-expand-xl">
            <div class="container large d-flex flex-row justify-content-xl-between align-items-center navbar-wrapper">
                <div class="d-flex flex-row align-items-center">
                    <div class="nav-logo mr-3 mr-lg-4">
                        <router-link to="/">
                            <img src="@/assets/img/nav-logo.png" lazy>
                        </router-link>
                    </div>

                    <div class="collapse navbar-collapse" id="navbarContent">
                        <ul class="navbar-nav">
                            <li class="nav-item px-3 nav-login">
                                <router-link to="/login" class="nav-link">Login / Register</router-link>
                            </li>
                            <li class="nav-item px-3">
                                <router-link to="/play" class="nav-link">Play</router-link>
                            </li>
                            <li class="nav-item px-3">
                                <router-link to="/store" class="nav-link">Store</router-link>
                            </li>
                            <li class="nav-item px-3">
                                <router-link to="/vote" class="nav-link">Vote</router-link>
                            </li>
                            <li class="nav-item px-3">
                                <a class="nav-link d-flex align-items-center gap-1"
                                href="https://discord.com/invite/3yt9kXRdax"
                                target="_blank">

                                    <!-- Tiny Discord icon -->
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#7289da"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.0371 19.7363 19.7363 0 00-4.8852 1.5152.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561 19.911 19.911 0 005.993 3.0406.0788.0788 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277 14.509 14.509 0 002.8007 1.3962.0743.0743 0 00.083-.0276c.2022-.2762.3954-.5682.5682-.8742a.076.076 0 01.0842-.0371c1.7753.5172 3.6805.5172 5.416 0a.0739.0739 0 01.083.0371c.1728.306.3659.598 0.5682.8742a.0741.0741 0 00.083.0276 14.5952 14.5952 0 002.8007-1.3962.076.076 0 01-.0076.1277 12.2986 12.2986 0 01-1.872.8923.0766.0766 0 00-.0417.1057c.3604.698.7719 1.362 1.2259 1.9942a.077.077 0 00.0842.0276 19.9415 19.9415 0 005.993-3.0406.077.077 0 00.0312-.0561c.5004-5.1779-.8382-9.6739-3.5485-13.6603a.061.061 0 00-.0312-.0277zM8.02 15.3312c-1.1825 0-2.1572-1.0857-2.1572-2.419 0-1.3332.9555-2.4189 2.1572-2.4189 1.2103 0 2.1757 1.0952 2.1573 2.419 0 1.3332-.9556 2.4189-2.1573 2.4189zm7.9748 0c-1.1826 0-2.1572-1.0857-2.1572-2.419 0-1.3332.9555-2.4189 2.1572-2.4189 1.2103 0 2.1757 1.0952 2.1573 2.419 0 1.3332-.947 2.4189-2.1573 2.4189z"/>
                                    </svg>

                                    Discord
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-end gap-2">
                    <div class="guest-actions user-signed-in">
                        <div class="dropdown">
                            <div v-if="!($store.getters.isLoggedIn)" class="d-flex flex-row-reverse">
                                <router-link to="/login" class="mb-0 text-white font-weight-bold"><i class="fas fa-user-circle mr-1"></i>Login/Register</router-link>
                            </div>
                            <!-- <a class="dropdown-toggle text-white" href="#" role="button" id="userMenu" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fas fa-download mr-2"></i>
                                <p class="mb-0">Play Free Now</p>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
                                <li><a class="dropdown-item" href="https://static.exiles-ps.com/Install-Exiles.exe" target="_blank"><i class="fab fa-windows mr-1"></i>Windows (64-bit)</a></li>
                                <li><a class="dropdown-item" href="https://static.exiles-ps.com/Install_Exiles_32-bit.exe" target="_blank"><i class="fab fa-windows mr-1"></i>Windows (32-bit)</a></li>
                                <li><a class="dropdown-item" href="https://static.exiles-ps.com/Exiles.app.zip" target="_blank"><i class="fab fa-apple mr-1"></i>MacOS</a></li>
                                <li><a class="dropdown-item" href="https://static.exiles-ps.com/Exiles.jar" target="_blank"><i class="fab fa-java mr-1"></i>Jar Launcher</a></li>
                            </ul> -->
                        </div>
                    </div>
                    <div v-if="($store.getters.isLoggedIn)" class="authenticated-actions ml-4">
                        <div class="dropdown">
                            <a class="dropdown-toggle text-white" href="#" role="button" id="userMenu" data-bs-toggle="dropdown" aria-expanded="false">
                                <p class="rank-styles plus-icon mb-0" :class="getRankSelector($store.state.user.privilege, $store.state.user.memberRank)">{{ $store.state.user.name }}</p>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
                                <li><router-link class="dropdown-item" to="/account"><i class="fas fa-user-circle mr-1"></i>Account</router-link></li>
                                <li class="logout"><a class="dropdown-item" href="#" @click.prevent="logout"><i class="fas fa-sign-out-alt mr-1"></i>Logout</a></li>
                            </ul>
                        </div>
                    </div>

                    <button type="button" class="navbar-toggle navbar-toggler" data-bs-toggle="collapse" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation" data-bs-target="#navbarContent" id="nav-btn">
                <input class="menu-icon" type="checkbox" id="menu-icon" name="menu-icon" onclick="checkFunction()"/>
                <label for="menu-icon"></label>
            </button>
                </div>
            </div>
        </nav>
</template>

<script>
import { rankMixin } from "@/mixins/rankMixin.js"

export default {
    mixins: [ rankMixin ],
    computed: {
        userRank() {
            return this.$store.state.user.privilege.toLowerCase().replace(' ', '-')
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/')
        }
    }
}
</script>
